import React, { useState, useEffect } from "react"

import Layout from "../components/layout"
import PricingTable from "../components/PricingTable"
import TabbedContent from "../components/TabbedContent"
import Quote from "../components/Quote"
import SEO from "../components/seo"
import ProfessionalServices from "../components/ProfessionalServices"
import axios from "axios"

const IndexPage = () => {
  const [countryName, setCountryName] = useState('United States');

  useEffect(() => {
      axios
      .get("https://ipapi.co/json/")
      .then(response => {
        let data = response.data;
        setCountryName(data.country_name)
      })
      .catch(error => {
        console.log(error)
      })

  }, [countryName])

  const currencySelect = () => {
    if (countryName === "United Kingdom") {
      return "£"
    } else {
      return "$"
    }
  }

  return (
    <Layout>
      <SEO
        title="Stack Pricing: Sales Enablement Software Prices"
        description="With subscriptions starting at just $400 a month, Stack is the salesconsultant in your pocket. We’ll help you approach investors and build your sales cycle."
      />
      <PricingTable
        currency={currencySelect()}
        content={
          <>
            <h1>Simple pricing, created with startups in mind.</h1>
            <p>
              Selling is hard and budgets are tight. In less than 60 seconds,
              Stack can get you started on a product that will guide you through
              the science of selling, making your sales process more efficient.
            </p>
          </>
        }
        footer={
          <>
            <p>
              Prices above are shown annually. For prices billed month-to-month,
              use the toggle. All packages are a 12 month term subscription.
            </p>
          </>
        }
      ></PricingTable>
      <ProfessionalServices
        currency={currencySelect()}
        content={
          <>
            <h2>Professional Services</h2>
            <p>
              If you’d like to learn about the services we provide around
              best-practices onboarding, quarterly accountability sessions and
              onsite/virtual implementation workshops, please email{" "}
              <a href="mailto:globalsales@stackglobal.io">
                globalsales@stackglobal.io
              </a>
              &nbsp; and we’ll get back with you in 24 hours to schedule a time to
              chat. We can’t wait!
            </p>
          </>
        }
      ></ProfessionalServices>
      <TabbedContent></TabbedContent>
      <Quote
        quote="After following the Stack process, we implemented a sales engine that resulted in us closing the year with 3X YoY growth, momentum that was carried into the next year. This clear, concise and focused sales process was a big part of our ability to be successful raising our Series A funding."
        position="Rasheed Hammouda"
        name="Co-Founder, CEO, BridgeFT"
      ></Quote>
    </Layout>
  )
}

export default IndexPage
